/* ============================================
   TRADUCTIONS FRANÇAISES (par défaut)
   ============================================ */

export const fr = {
  // États du match
  matchStates: {
    notStarted: 'Pas commencé',
    firstHalf: '1ère mi-temps',
    halfTime: 'Mi-temps',
    secondHalf: '2ème mi-temps',
    extraTimeFirstHalf: 'Prolongation',
    extraTimeHalfTime: 'Pause',
    extraTimeSecondHalf: 'Prolongation',
    penalties: 'Tirs au but',
    finished: 'Terminé',
    postponed: 'Reporté',
    cancelled: 'Annulé',
    interrupted: 'Interrompu',
  },

  // Événements
  events: {
    goal: 'But',
    yellowCard: 'Carton jaune',
    redCard: 'Carton rouge',
    substitution: 'Remplacement',
    corner: 'Corner',
    freeKick: 'Coup franc',
    penalty: 'Penalty',
    offside: 'Hors-jeu',
    injury: 'Joueur blessé',
    var: 'VAR',
    shotOnTarget: 'Frappe cadrée',
    shotOffTarget: 'Tir hors cadre',
    throwin: 'Touche',
    dangerousAttack: 'Attaque dangereuse',
    attack: 'Attaque',
    possession: 'Possession',
    sixMeters: '6 mètres',
    goalKick: 'Coup de pied de but',
    blockedShot: 'Tir bloqué',
    penaltyUnconfirmed: 'Penalty (à confirmer)',
    penaltyMissed: 'Penalty manqué',
    goalNotification: 'Notification de but',
    kickoff: 'Coup d\'envoi',
    secondHalfKickoff: 'Coup d\'envoi 2ème mi-temps',
    ballLost: 'Ballon perdu',
    ballRecovered: 'Ballon récupéré',
    ownGoal: 'But contre son camp',
    matchStart: 'Début',
    matchEnd: 'Fin',
    halfTimeScore: 'Score mi-temps',
    cardConfirmed: 'Carton confirmé',
    extraTimeEnded: 'Prolongation terminée',
    penaltyEnded: 'Penalty terminé',
    penaltyShootout: 'Penalty (TAB)',
    penaltyShootoutMissed: 'Penalty manqué (TAB)',
  },

  // Indicateurs de possession
  possession: {
    home: 'Possession domicile',
    away: 'Possession extérieur',
    attack: 'Attaque',
    dangerousAttack: 'Attaque dangereuse',
  },

  // Interface
  ui: {
    home: 'Domicile',
    away: 'Extérieur',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    connecting: 'Connexion...',
    loading: 'Chargement...',
    noMatch: 'Aucun match sélectionné',
    selectMatch: 'Sélectionner un match',
  },

  // Temps additionnel
  addedTime: {
    label: 'Temps additionnel',
    minute: 'min',
    minutes: 'min',
  },

  // Notifications
  notifications: {
    matchStarted: 'Début du match',
    matchEnded: 'Le match est terminé',
    halfTimeStarted: 'Mi-temps',
    secondHalfStarted: 'Reprise du match',
    matchAboutToStart: 'Le match va bientôt commencer',
    matchAboutToResume: 'Le match va bientôt reprendre',
    penaltiesInProgress: 'La séance est en cours',
    // Notifications d'événements centrés
    kickoffTitle: 'Coup d\'envoi',
    kickoffSubtitle: 'Le match est lancé !',
    goalTitle: 'But! but! but!',
    yellowCardTitle: 'Carton jaune',
    yellowCardSubtitle: 'Un joueur a pris un carton jaune',
    redCardTitle: 'Carton rouge',
    redCardSubtitle: 'Un joueur a pris un carton rouge',
    injuryTitle: 'Blessure',
    injurySubtitle: 'Un joueur est blessé',
    substitutionTitle: 'Remplacement',
    substitutionSubtitle: 'Changement en cours',
    varTitle: 'La VAR est en cours',
    varSubtitle: 'L\'arbitre va prendre sa décision',
    varCancelledTitle: 'But annulé',
    varCancelledSubtitle: 'Le but a été annulé par la VAR',
    addedTimeTitle: 'Temps additionnel',
    addedTimeSubtitle: 'On jouera des minutes en plus !',
  },

  // Indicateurs de terrain (UPPERCASE)
  fieldIndicators: {
    possession: 'POSSESSION',
    attack: 'ATTAQUE',
    dangerousAttack: 'ATTAQUE DANGEREUSE',
    throwin: 'TOUCHE',
    freeKick: 'COUP FRANC',
    dangerousFreeKick: 'COUP FRANC DANGEREUX',
    corner: 'CORNER',
    goalKick: '6 MÈTRES',
    penalty: 'PENALTY',
    shotOnTarget: 'FRAPPE CADRÉE',
    shotOffTarget: 'FRAPPE NON CADRÉE',
    offside: 'HORS-JEU',
    ballLost: 'BALLON PERDU',
  },

  // Compte à rebours
  countdown: {
    hours: 'H',
    minutes: 'MIN',
    seconds: 'SEC',
  },

  // Contrôles
  controls: {
    openRadar: 'Ouvrir le Radar',
    reload: 'Recharger',
    date: 'Date',
    match: 'Match',
    delay: 'Délai (secondes)',
    fieldLength: 'Longueur (px)',
    fieldWidth: 'Largeur (px)',
    fieldColor: 'Couleur du terrain',
    language: 'Langue',
    connectedStatus: 'Connecté',
    disconnectedStatus: 'Non connecté',
  },
};

